module.exports = __webpack_public_path__ + "img/huananligong.abe6ac72.png";